import {useSessionStorage} from '../../common/hooks/useSessionStorage';
import {UseStorageOptions, UseStorageResult} from '../../common/hooks/useStorage';
import {PostLoginState} from '../types';

export function usePostLoginSessionState(
  initialValue?: PostLoginState,
  options?: UseStorageOptions,
): UseStorageResult<PostLoginState> {
  return useSessionStorage<PostLoginState>('postLoginState', initialValue, options);
}
